import React from 'react';
import IconButton from '@mui/material/IconButton';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { connect } from 'react-redux';
import { useNavigate, useLocation } from 'react-router-dom';
import { fireEvent } from '../../utils/tracking';
import './CreativeTags.scss';

const handleClick = (tagName) => {
	fireEvent('Creative Detail Page', 'Click', `${tagName} Tag Clicked`);
};

const CreativeTagsForModal = ({ selectedCreative = {} }) => {
	const navigate = useNavigate();
	const location = useLocation();
	const origin = `${window.location.protocol}//${window.location.host}`;
	
  	// Or if you want to get the full URL (including the pathname)
  	const fullUrl = `${origin}${location.pathname}`;
	//   console.log("fullUrl",fullUrl)
	const query = new URLSearchParams(location.search);
	let postsales = '';
	const token = query.get('postsales');
	if (token != null) {
		postsales = 'postsales';
	}
	return (
		<div className="creativeTags">
			<div className="creativeTagsContent">
				{selectedCreative.region && (
					<a
						href={`${origin}/gallery?${postsales}&search=${selectedCreative.region.name}`}
						onClick={() => handleClick(selectedCreative.region.name)}
						className="creativeTag"
					>
						{selectedCreative.region.name}
					</a>
				)}
				{selectedCreative.brand && (
					<a
						href={`${origin}/gallery?${postsales}&brands=${selectedCreative.brand.name}`}
						onClick={() => handleClick(selectedCreative.brand.name)}
						className="creativeTag"
					>
						{selectedCreative.brand.name}
					</a>
				)}
				{selectedCreative.vertical && (
					<a
						href={`${origin}/gallery?${postsales}&verticals=${selectedCreative.vertical.name}`}
						onClick={() => handleClick(selectedCreative.vertical.name)}
						className="creativeTag"
					>
						{selectedCreative.vertical.name}
					</a>
				)}
				{Array.isArray(selectedCreative.formats) &&
					selectedCreative.formats.map((format) => (
						<a
							href={`${origin}/gallery?${postsales}&formats=${format.name}`}
							onClick={() => handleClick(format.name)}
							className="creativeTag"
							key={format.id}
						>
							{format.name}
						</a>
					))}
				{Array.isArray(selectedCreative.functionalities) &&
					selectedCreative.functionalities.map((functionality) => (
						<a
							href={`${origin}/gallery?${postsales}&functionalities=${functionality.name}`}
							onClick={() => handleClick(functionality.name)}
							className="creativeTag"
							key={functionality.id}
						>
							{functionality.name}
						</a>
					))}
				{Array.isArray(selectedCreative.specialtags) &&
					selectedCreative.specialtags.map((specialtag) => (
						<a
							href={`${origin}/gallery?${postsales}&search=${specialtag.name}`}
							onClick={() => handleClick(specialtag.name)}
							className="creativeTag"
							key={specialtag.id}
						>
							{specialtag.name}
						</a>
					))}
			</div>
		</div>
	);
};

const mapStateToProps = (state) => {
	return {
		selectedCreative: state.creativeReducer.selectedCreative,
	};
};

export default connect(mapStateToProps)(CreativeTagsForModal);
